import classNames from 'classnames';
import React from 'react';
import { Typography } from 'seagull';
import styles from "./ServicesSection.module.scss";
export default function ServicesSection(props) {
  const {
    title,
    subtitle,
    hasOptionalServices,
    category,
    children,
    'data-testid': testid
  } = props;
  return /*#__PURE__*/React.createElement("li", {
    className: classNames(styles.section, styles[category]),
    "data-testid": testid
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sectionHeader
  }, hasOptionalServices && category !== 'variable' && /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph3",
    skin: "secondary",
    "data-testid": testid && testid + '-has-optional'
  }, "Starts at"), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": testid && testid + '-title'
  }, title), subtitle && /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph3",
    weight: "normal",
    "data-testid": testid && testid + '-subtitle'
  }, subtitle)), /*#__PURE__*/React.createElement("ul", null, children));
}